import { useMemo } from 'react'
import { jornada } from 'service/api'
import { useStore } from 'store'
import { diarioColumns, mensalColumns } from '../columns'
import CentroCustosToolbar from '../toolbar/centro-custos-toolbar'
import { DigitacaoSubPages } from './DigitacaoSubPages'
import { useDigitacaoContext } from './useDigitacaoContext'

export default function DigitacaoCentroCustoPage() {
    const {
        view,
        periodo: [dataInicial, dataFinal],
    } = useDigitacaoContext()
    const funcionarioId = useStore(state => state.employeeId)
    const empresa = useStore(state => state.company)
    const empresaId = useStore(state => state.companyId)
    const centroCustoId = useStore(state => state.costCenterId)

    const {
        data: mensal,
        isLoading: isLoadingMensal,
        error: mensalError,
    } = jornada.mensal.useFetch({
        queryParams: {
            dataInicial,
            dataFinal,
            funcionarioId,
        },
        enabled: centroCustoId != -1 && funcionarioId > 0 && view === 'mensal',
    })

    const {
        data: diario,
        isLoading: isLoadingDiario,
        error: diarioError,
    } = jornada.diaria.useFetch({
        queryParams: {
            dia: dataInicial,
            empresaId,
            centroCustoId: centroCustoId === -1 ? undefined : centroCustoId,
        },
        enabled: centroCustoId != -1 && funcionarioId > 0 && view === 'diario',
    })

    const columns = useMemo(
        () =>
            view === 'mensal'
                ? mensalColumns(empresa?.exibirSaldoDiario == 'S')
                : diarioColumns,
        [view, empresa?.exibirSaldoDiario],
    )

    const errorMensal = (() => {
            if (mensalError) return mensalError
            if (centroCustoId === -1)
                return { message: 'Centro de custo não selecionado' }
        })(),
        errorDiario = (() => {
            if (diarioError) return diarioError
            if (centroCustoId === -1)
                return { message: 'Centro de custo não selecionado' }
        })()

    return (
        <DigitacaoSubPages
            Toolbar={CentroCustosToolbar}
            columns={columns}
            dataDiario={diario}
            dataMensal={mensal}
            diarioError={errorDiario}
            mensalError={errorMensal}
            isErrorDiario={!!errorDiario}
            isErrorMensal={!!errorMensal}
            isLoadingDiario={isLoadingDiario}
            isLoadingMensal={isLoadingMensal}
        />
    )
}
